<template>
  <div class="page flex-col">

    <div class="section_2 flex-col">
      <div class="group_1 flex-col">
        <div class="image-wrapper_1 flex-row">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG7ba570a83befcbe064b13fb9d24088c8.png'"
          />
          <img
            class="image_3"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG6a94e3f80b0a881a2f82b16ad3e3a8f8.png'"
          />
          <div style="margin-left: -48vw;margin-top:-4.2vw"> <headerMask/> </div>
        </div>
      </div>
      <div class="text-group_1 flex-col justify-between">
        <span class="text_2">以动健康产品价格</span>
        <span class="text_3">专业、透明、可预约、可定制</span>
      </div>
    </div>
    <div class="section_3 flex-col">
      <div class="text-wrapper_1 flex-row"><span class="text_4">免费试用，找到适合你的版本</span></div>
      <div class="group_2 flex-row">
        <div class="box_2 flex-row">
          <div class="text-wrapper_2 flex-col"><span class="text_5">个人版</span></div>
          <span class="text_6" @click="toPage('quotation_2')">便携工作站</span>
          
          <span class="text_7"  @click="toPage('quotation_3')">旗舰工作站</span>
        </div>
      </div>
      <div class="group_4 flex-row">
        <div class="section_4 flex-col">
          <div class="text-wrapper_3">
            <span class="text_8">低至：</span>
            <span class="text_9">65</span>
            <span class="text_10"></span>
            <span class="text_11">元/月</span>
          </div>
          <div style="cursor: pointer;" @click="toTools" class="text-wrapper_4 flex-col"><span class="text_12">免费试用</span></div>
          <div class="text-wrapper_5">
            <span class="text_13">适用于</span>
            <span class="text_14">治疗师个人，健身教练，小型工作室</span>
          </div>
          <div class="image-text_1 flex-row justify-between">
            <img
              class="thumbnail_3"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_2">3000+高清带解析的运动视频及分解图</span>
          </div>
          <div class="image-text_2 flex-row justify-between">
            <img
              class="thumbnail_4"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_3">50余种疾病，涵盖骨科慢性疼痛，术后康复，三高慢性病等的运动康复计划</span>
          </div>
          <div class="image-text_3 flex-row justify-between">
            <img
              class="thumbnail_5"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_4">70余种肌肉群组的运动方式</span>
          </div>
          <div class="image-text_4 flex-row justify-between">
            <img
              class="thumbnail_6"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_5">200余种骨科康复特殊评估实验</span>
          </div>
          <div class="image-text_5 flex-row justify-between">
            <img
              class="thumbnail_7"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_6">发送问卷功能</span>
          </div>
          <div class="image-text_6 flex-row justify-between">
            <img
              class="thumbnail_8"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_7">公共模板节省时间学习运动处方</span>
          </div>
          <div class="image-text_7 flex-row justify-between">
            <img
              class="thumbnail_9"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_8">个人模板创建自己的运动康复模板</span>
          </div>
          <div class="image-text_8 flex-row justify-between">
            <img
              class="thumbnail_10"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_9">无限量的运动计划</span>
          </div>
          <div class="image-text_9 flex-row justify-between">
            <img
              class="thumbnail_11"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_10">无限的病人数量</span>
          </div>
          <div class="image-text_10 flex-row justify-between">
            <img
              class="thumbnail_12"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_11">免费的患者端小程序应用：以动Rehab</span>
          </div>
          <div class="image-text_11 flex-row justify-between">
            <img
              class="thumbnail_13"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_12">显示机构/治疗师名字的视频及打印版处方</span>
          </div>
          <div class="image-text_12 flex-row justify-between">
            <img
              class="thumbnail_14"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_13">免费在线培训课程</span>
          </div>
          <div class="image-text_13 flex-row justify-between">
            <img
              class="thumbnail_15"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_14">每周7天的客服支持</span>
          </div>
          <div class="image-text_14 flex-row justify-between">
            <img
              class="thumbnail_16"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG01a57ffd45106446d682f5fe9f0a643e.png'"
            />
            <span class="text-group_15">硬件设备（可升级购买定制版Pad）</span>
          </div>
          <div class="text-wrapper_6 flex-col"><span class="text_15">个人版</span></div>
        </div>
      </div>

      <div class="group_8 flex-row">
        <div class="group_9 flex-col"></div>
        <img
          class="thumbnail_19"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/b56db1691d3f445e80410538a924f948_mergeImage.png'"
        />
        <div class="image-text_16 flex-row justify-between">
          <div class="block_1 flex-col">
            <div class="group_10 flex-col"></div>
            <span class="text-group_17">典型项目案例展示</span>
          </div>
          <div class="image-wrapper_3 flex-col">
            <img
              class="thumbnail_20"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <div class="group_11 flex-row justify-between">
        <img
          class="thumbnail_21"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG075ce7ed400dc9c1683ddc509a884e1f.png'"
        />
        <div class="image-wrapper_4 flex-row">
          <img
            class="image_4"
            referrerpolicy="no-referrer"
            v-lazy="item.lanhuimage0"
            v-for="(item, index) in loopData0"
            :key="index"
          />
        </div>
        <img
          class="thumbnail_22"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG7b1d2039782e29ca05547eeefe55996a.png'"
        />
      </div>
    </div>
    <div class="section_6 flex-col">
      <div class="text-group_18 flex-col justify-between">
        <span class="text_16">联系方式</span>
        <span class="text_17">contact&nbsp;information</span>
      </div>
      <div class="text-group_19 flex-col justify-between">
        <span class="text_18">132-2019-0868</span>
        <span class="text_19">北京市顺义区中关村科技园区顺义园汇海中路7号院221-03室</span>
      </div>
      <div class="text-group_20 flex-col justify-between">
        <span class="text_20">info&#64;ktangtang.com</span>
        <span class="text_21">https://ktangtang.com</span>
      </div>
    </div>
  <footerMask/>
    <img
      class="image_7"
      referrerpolicy="no-referrer"
      v-lazy="'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG36f687d7a1e324e88c0e7a2e52d37b75.png'"
    />
  </div>
</template>
<script>
import headerMask from "../../components/headery";
import footerMask from "../../components/footert";

export default {
  components: {
    headerMask,
    footerMask
  },
  data() {
    return {
      loopData0: [
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG92865307e079109c55ce86e1a50a1141.png'
        },
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNGca4d46e6bebd85a82a4edb60bf79b4c7.png'
        },
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG28fb40480630188a21cbd8883956b251.png'
        },
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG56e86d642286fcd631d21b2fd4692a6f.png'
        },
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG6e983b5e2471ed1c5f7024c22ef5c273.png'
        },
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/quotation_h5/FigmaDDSSlicePNG0d9ad919e9d0142ef3225f57cb9238ca.png'
        }
      ],
      constants: {}
    };
  },
  async mounted() {
    
    let weight = window.screen.width
    console.log(weight, 'ddddddddddddd')
    if(weight >= 1200){
      this.$router.push({path: '/quotation'})
    }
  
  },
  methods: {
    toTools(){
          window.location.href=  'https://yd-tool.ktangtang.com/login'
    },
    toPage(e){
      this.$router.push({path: e})
    }

  }
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />